define((require) => {
    "use strict";

    const ImprovedView = require("editor/zbone/ImprovedView");
    const template = require("ui/reporting/MatomoReportingView.tpl");
    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");
    const $ = require("jquery");

    return ImprovedView.extend("ReportingView", {

        className: "dashboard-reporting-view",

        template,

        _segmentDimension: null,

        ui: {
            matomoRegion: ".matomo-region"
        },
        /**
        * This is an empty filler class that is necessary
        *
        * @see DashboardView#showTab
        */
        getCountableEventSource() {
            var empty = [];
            return empty;
        },
        /**
         *
         * What we return if reporting is not enabled.
         * @private
         */
        _reportingNotEnabled: function() {
            var defaultThumbnail = document.createElement("DIV");
            defaultThumbnail.innerHTML += "Reporting Not Enabled <p> Contact Your Account Manager to Gain Access";
            defaultThumbnail.style.cssText = "text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default; margin:100px";
            this.append(defaultThumbnail);
        },

        /**
        *
        * Renders a message if reporting is not enabled.
        *
        * If reporting is enabled we use the MatomoReporting model to send a call to
        * the matomo auth wrapper which then returns html that we render in an iframe.
        *
        */
        onRender() {
            const self = this;
            if (LoggedInUserState.get("integrations").isMatomoReportingDashboardLinkVisibleIntegrationsEnabled()) {
                self.ui.matomoRegion.append(self.options.get("html"));
                // We know that there is a single matomo region and node because we've set it the line before
                var iframe = self.ui.matomoRegion[0].childNodes[0];
                // Adding class for .less file
                $(iframe).addClass("matomo-iframe");
                $(iframe).attr("scrolling", "auto");
            } else {
                self._reportingNotEnabled();
            }
        }


    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/reporting/MatomoReportingView.js